import angleRight from '../../../assets/svg/angle-right.svg';
const plusIcon = true; // Set to false to use angle right icon
const titleIcon = plusIcon ? '' : angleRight;
const titleIconClass = plusIcon ? 'panels__plus-icon' : '';

class Panel {
	constructor(node) {
		this.node = node;
		this.openedClass = 'panels__panel--opened';
		this.opened = this.node.classList.contains(this.openedClass);
		this.title = this.node.querySelector('.panels__title');
		this.content = this.node.querySelector('.panels__content');

		// Find the panel image block (hidden) inside this panel.
		this.panelImage = this.node.querySelector('.panel__image');
		this.panelImageUrl = this.panelImage
			? this.panelImage.dataset.panelImage
			: null;

		// Save instance on the node for sibling access.
		this.node.panelInstance = this;

		if (this.title) {
			this.title.insertAdjacentHTML(
				'beforeend',
				`<span class="panels__toggle ${titleIconClass}">${titleIcon}</span>`
			);
			this.title.addEventListener('click', () => this.toggle());
		}
	}

	// Utility: Update the main image in the right column.
	updateMainImage() {
		const mainImage = document.querySelector('.panels__image');
		if (mainImage) {
			mainImage.src = this.panelImageUrl ? this.panelImageUrl : "";
		}
	}

	open() {
		this.node.classList.add(this.openedClass);
		this.opened = true;
		this.title.setAttribute('aria-expanded', 'true');

		// Update main image.
		this.updateMainImage();

		// Animate the opening of the panel content.
		this.content.style.display = 'flow-root';
		this.content.style.position = 'absolute';
		let height = this.content.offsetHeight;
		this.content.style.position = '';
		this.content.style.height = '0px';
		this.content.style.overflow = 'hidden';

		let transitionend = (e) => {
			if (e.propertyName === 'height') {
				this.content.removeAttribute('style');
				this.content.removeEventListener('transitionend', transitionend);
			}
		};

		this.content.addEventListener('transitionend', transitionend);
		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'ease-out, linear';

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = `${height}px`;
				this.content.style.opacity = 1;
			});
		});
	}

	close() {
		this.node.classList.remove(this.openedClass);
		this.opened = false;
		this.title.setAttribute('aria-expanded', 'false');
		this.content.style.display = 'block';
		this.content.style.overflow = 'hidden';
		this.content.style.height = `${this.content.offsetHeight}px`;
		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'ease-out, linear';

		let transitionend = (e) => {
			if (e.propertyName === 'height') {
				this.content.removeAttribute('style');
				this.content.removeEventListener('transitionend', transitionend);
				const openPanels = document.querySelectorAll('.panels__panel--opened');
				if (openPanels.length === 0) {
					const mainImage = document.querySelector('.panels__image');
					if (mainImage) {
						mainImage.src = "";
					}
				}
			}
		};

		this.content.addEventListener('transitionend', transitionend);

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = '0';
				this.content.style.opacity = 0;
			});
		});
	}

	toggle() {
		const panelsContainer = this.node.closest('.panels');
		// Read the allowMultiple attribute from the parent container.
		const allowMultiple = panelsContainer.getAttribute('data-allow-multiple') === 'true';

		if (!this.opened) {
			if (!allowMultiple) {
				const siblingPanels = panelsContainer.querySelectorAll('.panels__panel');
				siblingPanels.forEach((panelNode) => {
					if (
						panelNode !== this.node &&
						panelNode.classList.contains(this.openedClass)
					) {
						if (panelNode.panelInstance) {
							panelNode.panelInstance.close();
						}
					}
				});
			}
			this.open();
		} else {
			this.close();
		}
	}
}

class Panels {
	constructor(node) {
		this.node = node;
		this.node.classList.add('panels--interactive');
		this.panels = Array.from(this.node.querySelectorAll('.panels__panel')).map(
			(node) => new Panel(node)
		);
		const allowMultiple = this.node.getAttribute('data-allow-multiple') === 'true';

		if (!allowMultiple) {
			const openPanels = this.panels.filter(panel => panel.opened);
			if (openPanels.length === 0 && this.panels.length > 0) {
				this.panels[0].open();
			} else if (openPanels.length > 1) {
				openPanels.slice(1).forEach(panel => panel.close());
			}
		} else {
			const openPanels = this.panels.filter(panel => panel.opened);
			if (openPanels.length > 0) {
				openPanels[0].updateMainImage();
			}
		}
	}
}

Panels.instances = Array.from(document.querySelectorAll('.panels')).map(
	(p) => new Panels(p)
);

export default Panels;
